// extracted by mini-css-extract-plugin
export default {"providerLetter":"ProviderBlock_providerLetter__cCDnJ","wrapperStyles":"ProviderBlock_wrapperStyles__h1Pv1"};